import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'parseCheckbox',
})
export class ParseCheckboxPipe implements PipeTransform {
  transform(value: boolean): 'SI' | 'NO' {
    return value ? 'SI' : 'NO';
  }
}
